<template>
	<div class="mainloading" :class="{fadeOut: !isShow}" v-show="canShow">
		<div class="mainloading-box">
			<div class="mainloading-con">
				<div class="mainloading-bar" :style="{'width': displayProgressNumStr + '%'}">
					<span class="mainloading-per po">{{ displayProgressNumStr + '%' }}</span>
					<img class="mainloading-icon" src="data:image/jpg;base64,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" />
				</div>
				<div class="po mainloading-waiting" v-show="canWaitShow">{{ statusText }}</div>
			</div>
		</div>
		<div class="mainloading-tips">
			<p class="tips-icon">💡</p>
			<transition name="tips-fade" mode="out-in">
				<p class="tips-text" :key="currentTipIndex">{{ currentTip }}</p>
			</transition>
		</div>
		<st-toast-confirm
			v-if="auditRejectToastRender"
			v-model="auditRejectToastShow"
			whereClose="none"
			:showCancel="auditRejectAction === 'manual_review'"
			:title="auditRejectToastTitle"
			:content="auditRejectToastContent"
			:cancelText="auditRejectAction === 'manual_review' ? '提交人工审核' : '取消'"
			:confirmText="auditRejectAction === 'manual_review' ? '移除并重试' : '确定'"
			@onConfirm="onAuditRejectConfirm"
			@onCancel="onAuditRejectCancel"
			@changeShowStatus="onAuditRejectToastChange">
			<div v-if="auditRejectAction === 'manual_review'" class="audit-reject-slot">
				<div class="audit-reject-preview" v-if="auditRejectedImageUrl">
					<img class="audit-reject-preview-img" :src="auditRejectedImageUrl" />
				</div>
				<div class="audit-reject-slot-text">
					<div class="audit-reject-slot-title">检测到第 {{ auditRejectedImageIndex + 1 }} 张图片存在风险</div>
					<div class="audit-reject-slot-desc">您可以先移除这张图片后重新尝试，也可以提交人工审核。</div>
				</div>
			</div>
		</st-toast-confirm>
		<st-toast-confirm
			v-model="auditTimeoutToastShow"
			whereClose="none"
			:showCancel="true"
			:title="auditTimeoutToastTitle"
			:content="auditTimeoutToastContent"
			confirmText="继续等待"
			cancelText="稍后再试"
			@onConfirm="onAuditTimeoutConfirm"
			@onCancel="onAuditTimeoutCancel"
			@changeShowStatus="onAuditTimeoutToastChange">
		</st-toast-confirm>
	</div>
</template>

<script>
import { useTips } from './composables/useTips';
import { useMonitor } from './composables/useMonitor';
import { useImageLoader } from './composables/useImageLoader';
import { useAudit } from './composables/useAudit';
import { ENABLE_AUDIT_DEBUG_LOG, TIPS } from './utils/constants';
import StToastConfirm from '@/components/st_comps/st_comp/comps/StToast/StToastConfirm.vue';

function createTimerPromise(delay) {
	return new Promise(resolve => {
		setTimeout(resolve, delay);
	});
}

// 平滑动画参数
const PROGRESS_ANIMATION_DURATION = 500; // 每次进度变化的动画时长（毫秒）
/*
Mainloading 本地审核调试说明

用法：
1. 仅在 ISDEBUG = 1 时生效
2. 在 `index.js` 里修改 `AUDIT_DEBUG_SCENARIO`
3. 例如：`'rejected'`、`'failed'`、`'poll_job_not_found'`
4. 置空字符串 `''` 即恢复真实流程
5. debug 下真实 createJob / getJob 请求仍会发出，你可以在 Network 里看到
6. debug 不再 merge 真实响应和 mock 响应，页面只吃场景脚本返回
7. 真实响应当前只用于确保请求真的发出，并沿用真实 create 返回的 jobId 去轮询
8. 前端后续仍然走同一套 createJob -> getJob -> 轮询 -> 终态判断 -> toast / 页面收口逻辑，不会为了 debug 额外走一套分支

可用值：
- `success`
  创建接口返回 `queued`，轮询先经过 `running`，最终返回 `passed`
- `passed`
  创建接口返回 `queued`，轮询直接返回 `passed`
- `rejected`
  创建接口返回 `queued`，轮询返回 `rejected`
- `failed`
  创建接口返回 `queued`，轮询返回 `failed`
- `timeout`
  创建接口返回 `queued`，轮询返回 `timeout`
- `poll_running_then_passed`
  创建接口先返回 `queued`，轮询先返回 `running`，再返回 `passed`
- `create_invalid_params`
  创建接口直接返回 `INVALID_PARAMS`
- `create_no_images`
  创建接口直接返回 `NO_IMAGES`
- `create_image_fetch_error`
  创建接口直接返回 `IMAGE_FETCH_ERROR`
- `create_dispatch_failed`
  创建接口直接返回 `DISPATCH_FAILED`
- `create_job_store_unavailable`
  创建接口直接返回 `JOB_STORE_UNAVAILABLE`
- `poll_job_not_found`
  创建成功后，轮询返回 `JOB_NOT_FOUND`
- `poll_job_store_unavailable`
  创建成功后，轮询返回 `JOB_STORE_UNAVAILABLE`
- `request_error_create`
  创建请求直接抛出非接口格式错误，用于验证网络/异常兜底
- `request_error_poll`
  轮询请求直接抛出非接口格式错误，用于验证网络/异常兜底
- `timeout_create`
  创建请求直接超时
- `timeout_poll`
  轮询请求直接超时
*/

export default {
	name: 'MainLoading',
	components: {
		StToastConfirm
	},
	data () {
		return {
			isShow: true,
			canShow: true,
			options: {
				images: [],
				auditBaseUrl: '',
				auditBaseUrlMode: 'auto',
				auditDebugScenario: '',
				onUpdate: null,
				onEnd: null
			},
			progressNum: 0,           // 真实进度（0-100）
			displayProgressNum: 0,    // 显示进度（带平滑动画）
			ended: false,
			canWaitShow: false,
			canWaitEvent: null,
			hideEvent: null,
			loadToken: 0,
			statusText: '',
			currentTipIndex: 0,

			// 审核相关
			auditFinishedCount: 0,
			auditTotalCount: 0,
			auditRejectToastShow: false,
			auditRejectToastRender: false,
			auditRejectToastTitle: '⚠️注意',
			auditRejectToastContent: [
				'🔴 相册因内容异常已被「临时保护」，',
				'🔴 内容待管理员「审核后恢复」，',
				'🔴 请您耐心等待，谢谢'
			],
			auditRejectAction: 'reload',
			auditRejectedImageIndex: -1,
			auditRejectedImageUrl: '',
			auditRejectedPayload: null,

			// 审核轮询上限提示
			auditTimeoutToastShow: false,
			auditTimeoutToastTitle: '⏳ 审核次数已达上限',
			auditTimeoutToastContent: [
				'当前图片较多，审核仍在进行中...',
				'您可以继续等待，或稍后再试。'
			],
			auditTimeoutDecisionResolver: null,

			// 加载相关
			loadFinishedCount: 0,
			loadTotalCount: 0,

			// 内部状态
			_auditTokenRef: { current: 0 },
			_loadTokenRef: { current: 0 },
			_onTimeoutRetry: null,
			_progressAnimFrameId: null,
			_progressAnimStartValue: 0,
			_progressAnimTargetValue: 0,
			_progressAnimStartTime: 0,
			currentAlbumKey: ''
		}
	},
	computed: {
		progressNumStr () {
			return Math.round(this.progressNum);
		},
		displayProgressNumStr () {
			return Math.round(this.displayProgressNum);
		},
		currentTip () {
			return TIPS[this.currentTipIndex];
		}
	},
	created () {
		this._tipsHelper = useTips();
		this._monitorHelper = useMonitor();
		this._imageLoaderHelper = useImageLoader();
		this._auditHelper = useAudit();

		this._tipsHelper.startTipsRotation((index) => {
			this.currentTipIndex = index;
		}, 5000);
	},
	beforeDestroy () {
		this._cleanup();
	},
	methods: {
		_cleanup () {
			if (this._tipsHelper) {
				this._tipsHelper.stopTipsRotation();
			}
			if (this._auditHelper) {
				this._auditHelper.abortAll('component_destroy');
				this._auditHelper.clearPollTimer();
			}
			if (this.canWaitEvent) {
				clearTimeout(this.canWaitEvent);
				this.canWaitEvent = null;
			}
			if (this.hideEvent) {
				clearTimeout(this.hideEvent);
				this.hideEvent = null;
			}
			if (this._progressAnimFrameId) {
				cancelAnimationFrame(this._progressAnimFrameId);
				this._progressAnimFrameId = null;
			}
		},

		// ==================== 平滑进度条动画 ====================

		/**
		 * 开始平滑动画到目标进度
		 * @param {number} targetProgress - 目标进度（0-100）
		 */
		animateProgressTo (targetProgress) {
			this.progressNum = targetProgress;

			// 取消上一次动画
			if (this._progressAnimFrameId) {
				cancelAnimationFrame(this._progressAnimFrameId);
				this._progressAnimFrameId = null;
			}

			// 如果没有变化，直接设置
			if (Math.abs(this.displayProgressNum - targetProgress) < 0.1) {
				this.displayProgressNum = targetProgress;
				return;
			}

			// 记录动画起始状态
			this._progressAnimStartValue = this.displayProgressNum;
			this._progressAnimTargetValue = targetProgress;
			this._progressAnimStartTime = Date.now();

			// 开始动画
			this._runProgressAnimation();
		},

		/**
		 * 使用 requestAnimationFrame 执行进度动画
		 */
		_runProgressAnimation () {
			const now = Date.now();
			const elapsed = now - this._progressAnimStartTime;
			const progress = Math.min(elapsed / PROGRESS_ANIMATION_DURATION, 1);

			// 使用 easeOutCubic 缓动函数，让动画更自然
			const easeProgress = 1 - Math.pow(1 - progress, 3);

			// 计算当前值
			this.displayProgressNum =
				this._progressAnimStartValue +
				(this._progressAnimTargetValue - this._progressAnimStartValue) * easeProgress;

			// 动画未结束，继续下一帧
			if (progress < 1) {
				this._progressAnimFrameId = requestAnimationFrame(() => {
					this._runProgressAnimation();
				});
			} else {
				// 动画结束，确保最终值准确
				this.displayProgressNum = this._progressAnimTargetValue;
				this._progressAnimFrameId = null;
			}
		},

		show () {
			this.isShow = true;
			this.canShow = true;
		},

		hide () {
			this.isShow = false;
			this.canShow = false;
		},

		isAuditDebugLogEnabled () {
			return Boolean(
				ENABLE_AUDIT_DEBUG_LOG &&
				this.$util &&
				this.$util.$config &&
				this.$util.$config.ISDEBUG
			);
		},

		logAuditEvent (eventName, payload) {
			if (!this.isAuditDebugLogEnabled()) {
				return;
			}
			console.log('[MainloadingServe][audit]', eventName, payload || {});
		},

		getAuditTerminalState (err) {
			if (!err) {
				return 'system_error';
			}
			if (err.code === 'audit_rejected') {
				return 'rejected';
			}
			if (err.code === 'audit_poll_limit_give_up') {
				return 'poll_limit_give_up';
			}
			if (
				err.code === 'component_destroy'
				|| err.code === 'system_error'
				|| err.code === 'audit_rejected'
				|| err.code === 'load_replaced'
				|| err.code === 'aborted'
			) {
				return 'cancelled';
			}
			return 'system_error';
		},

		async handleAuditTerminalState (terminalState, payload = {}) {
			this.logAuditEvent('terminal_state', {
				terminalState,
				reasonCode: payload && payload.reasonCode ? payload.reasonCode : '',
				message: payload && payload.message ? payload.message : '',
				extra: payload && payload.extra ? payload.extra : {}
			});

			if (terminalState === 'cancelled') {
				return;
			}

			if (terminalState === 'rejected') {
				this.prepareAuditRejectToast(payload && payload.extra ? payload.extra : {});
				this._monitorHelper.sendFrontendMonitor({
					monitorType: 'event',
					eventName: 'mainloading_audit_rejected',
					auditStatus: 'rejected',
					message: 'mainloading audit rejected',
					extra: payload && payload.extra ? payload.extra : {}
				});
				this.showAuditRejectToast();
				return;
			}

			if (terminalState === 'poll_limit_give_up') {
				this.refreshPage();
				return;
			}

			this.handleSystemError(
				payload && payload.message ? payload.message : '审核请求失败',
				payload && payload.reasonCode ? payload.reasonCode : 'audit_system_error'
			);
		},

		// ==================== 进度计算 ====================

		updateProgress () {
			const totalSteps = this.auditTotalCount + this.loadTotalCount;
			if (!totalSteps) {
				this.animateProgressTo(100);
				return;
			}
			const currentSteps = this.auditFinishedCount + this.loadFinishedCount;
			const progressNum = (currentSteps / totalSteps) * 100;
			this.animateProgressTo(progressNum > 100 ? 100 : progressNum);
		},

		// ==================== 加载入口 ====================

		resetLoadState () {
			this._cleanup();
			this.progressNum = 0;
			this.displayProgressNum = 0;
			this.isShow = true;
			this.canShow = true;
			this.ended = false;
			this.canWaitShow = false;
			this.statusText = '';
			this.auditRejectToastShow = false;
			this.auditRejectToastRender = false;
			this.auditTimeoutToastShow = false;
			this.auditTimeoutDecisionResolver = null;
			this.auditFinishedCount = 0;
			this.auditTotalCount = 0;
			this.loadFinishedCount = 0;
			this.loadTotalCount = 0;
			this.currentAlbumKey = '';
			this.auditRejectedImageIndex = -1;
			this.auditRejectedImageUrl = '';
			this.auditRejectedPayload = null;
			this._auditTokenRef = { current: 0 };
			this._loadTokenRef = { current: 0 };
		},

		load () {
			const currentToken = ++this.loadToken;

			const storeImages = (this.$store && this.$store.state && Array.isArray(this.$store.state.images)) ? this.$store.state.images : [];
			const optionImages = Array.isArray(this.options.images) ? this.options.images : [];
			const auditImages = this._auditHelper.buildAuditImages(storeImages, optionImages);
			const auditBaseUrl = this._auditHelper.resolveAuditBaseUrl(
				this.options.auditBaseUrl,
				this.options.auditBaseUrlMode,
				this.$util && this.$util.$config,
				this.$store && this.$store.state && this.$store.state.config
			);
			const auditDebugScenario = this.isAuditDebugLogEnabled()
				? (this.options.auditDebugScenario || '')
				: '';
			const albumKey = this._auditHelper.getAlbumKey(
				this.$util && this.$util.$router && this.$util.$router.params,
				this.$store && this.$store.state && this.$store.state.data
			);

			this.resetLoadState();

			this._monitorHelper.sendFrontendMonitor({
				monitorType: 'event',
				eventName: 'mainloading_load_start',
				message: 'mainloading serve load start',
				extra: {
					auditImageCount: auditImages.length,
					loadImageCount: optionImages.length
				}
			});

			this.auditTotalCount = auditImages.length;
			this.loadTotalCount = optionImages.length;
			this.currentAlbumKey = albumKey;

			const totalCount = this.auditTotalCount + this.loadTotalCount;
			if (!totalCount) {
				this.__onEnd();
				return;
			}

			this.canWaitEvent = setTimeout(() => {
				if (this.ended === false && this.loadToken === currentToken) {
					this.canWaitShow = true;
				}
			}, 6000);

			if (!auditImages.length) {
				this.startLoadQueue(currentToken, optionImages);
				return;
			}

			this.startServerAudit(currentToken, {
				auditBaseUrl,
				auditDebugScenario,
				albumKey,
				auditImages,
				optionImages
			});
		},

		isTokenValid (currentToken) {
			return this.loadToken === currentToken;
		},

		canContinue (currentToken) {
			return this.isTokenValid(currentToken) && this.ended === false;
		},

		// ==================== 审核流程 ====================

		async startServerAudit (currentToken, { auditBaseUrl, auditDebugScenario, albumKey, auditImages, optionImages }) {
			try {
				await this._auditHelper.startServerAudit(
					{
						auditBaseUrl,
						debugScenario: auditDebugScenario,
						albumKey,
						auditImages,
						onStatusChange: (text, finishedCount, totalCount) => {
							this.setAuditStatusText(text, finishedCount, totalCount);
						},
						onProgress: (finishedCount, totalCount) => {
							this.auditFinishedCount = finishedCount;
							this.updateProgress();
						},
						onTimeout: ({ pollCount, maxPollCount }) => {
							return this.showAuditTimeoutToast(pollCount, maxPollCount);
						},
						onMonitor: (payload) => {
							this._monitorHelper.sendFrontendMonitor(payload);
						},
						isDebugLogEnabled: () => this.isAuditDebugLogEnabled()
					},
					this._auditTokenRef,
					(token) => this.canContinue(currentToken) && this._auditTokenRef.current === token
				);

				if (!this.canContinue(currentToken)) {
					return;
				}

				if (this.auditFinishedCount !== this.auditTotalCount) {
					this.auditFinishedCount = this.auditTotalCount;
					this.updateProgress();
				}

				if (!optionImages.length) {
					this.statusText = '加载成功，内容安全';
					this.__onEnd();
					return;
				}

				this.startLoadQueue(currentToken, optionImages);
				} catch (err) {
					if (!this.canContinue(currentToken)) {
						return;
					}

					const terminalState = this.getAuditTerminalState(err);
					if (terminalState === 'cancelled') {
						return;
					}

				await this.handleAuditTerminalState(terminalState, {
					message: err && err.message ? err.message : '审核请求失败',
					reasonCode: err && err.code ? err.code : 'audit_system_error',
					extra: err && err.payload ? err.payload : {}
				});
			}
		},

		setAuditStatusText (prefix, finishedCount, totalCount) {
			const count = totalCount || this.auditTotalCount || 0;
			this.statusText = `${prefix}（${finishedCount || this.auditFinishedCount}/${count}）`;
			this.canWaitShow = true;
		},

		// ==================== 超时弹窗 ====================

		showAuditTimeoutToast (pollCount, maxPollCount) {
			this.auditTimeoutToastTitle = '⏳ 请稍等';
			this.auditTimeoutToastContent = [
				`内容正在安全检查，请您耐心等一会儿。`,
				'您也可以稍后再回来操作。'
			];
			this.auditTimeoutToastShow = true;

			return new Promise((resolve) => {
				this.auditTimeoutDecisionResolver = resolve;
			});
		},

		onAuditTimeoutConfirm () {
			this.auditTimeoutToastShow = false;
			if (typeof this.auditTimeoutDecisionResolver === 'function') {
				this.auditTimeoutDecisionResolver('retry');
			}
			this.auditTimeoutDecisionResolver = null;
		},

		onAuditTimeoutCancel () {
			this.auditTimeoutToastShow = false;
			if (typeof this.auditTimeoutDecisionResolver === 'function') {
				this.auditTimeoutDecisionResolver('give_up');
			}
			this.auditTimeoutDecisionResolver = null;
		},

		onAuditTimeoutToastChange (show) {
			this.auditTimeoutToastShow = show;
		},

		// ==================== 图片加载 ====================

		startLoadQueue (currentToken, optionImages) {
			this._imageLoaderHelper.startLoadQueue(
				optionImages,
				{
					onUpdate: (image, imageObject, isError) => {
						this.options.onUpdate && this.options.onUpdate(image, imageObject);
					},
					onProgress: (finishedCount, totalCount) => {
						this.loadFinishedCount = finishedCount;
						this.updateProgress();
					},
					onStatusChange: (text) => {
						this.setLoadStatusText(text);
					},
					onEnd: () => {
						this.statusText = '加载成功，内容安全';
						this.__onEnd();
					}
				},
				this._loadTokenRef,
				(token) => this.canContinue(currentToken) && this._loadTokenRef.current === token
			);
		},

		setLoadStatusText (prefix) {
			const totalCount = this.loadTotalCount || 0;
			this.statusText = `${prefix}（${this.loadFinishedCount}/${totalCount}）`;
			this.canWaitShow = true;
		},

		// ==================== 错误处理 ====================

		getRejectedPreviewUrl (rejectedImageIndex, auditPayload = {}) {
			if (auditPayload && auditPayload.rejectedImageUrl) {
				return auditPayload.rejectedImageUrl;
			}

			const storeImages = (this.$store && this.$store.state && Array.isArray(this.$store.state.images))
				? this.$store.state.images
				: [];
			const configImages = (this.$store && this.$store.state && this.$store.state.config && Array.isArray(this.$store.state.config.images))
				? this.$store.state.config.images
				: [];
			const storeImage = storeImages[rejectedImageIndex];
			const configImage = configImages[rejectedImageIndex];

			if (storeImage && storeImage.im) {
				return storeImage.im;
			}

			if (configImage && configImage.im) {
				return configImage.im;
			}

			if (configImage && this.$util && typeof this.$util.packageIm === 'function') {
				return this.$util.packageIm(configImage);
			}

			return '';
		},

		prepareAuditRejectToast (auditPayload = {}) {
			const rejectedImageIndex = typeof auditPayload.rejectedImageIndex === 'number'
				? auditPayload.rejectedImageIndex
				: -1;

			this.auditRejectedPayload = auditPayload;
			this.auditRejectedImageIndex = rejectedImageIndex;
			this.auditRejectedImageUrl = this.getRejectedPreviewUrl(rejectedImageIndex, auditPayload);
		},

		async requestBlockAlbum (auditPayload = {}) {
			const albumKey = (auditPayload && auditPayload.albumKey) || this.currentAlbumKey || '';

			if (!albumKey) {
				this.logAuditEvent('block_album_skip', {
					reason: 'missing_album_key'
				});
				this._monitorHelper.sendFrontendMonitor({
					monitorType: 'event',
					eventName: 'mainloading_block_album_skip',
					message: 'skip block album request',
					extra: {
						reason: 'missing_album_key'
					}
				});
				return;
			}

			this.logAuditEvent('block_album_start', {
				albumKey
			});

			try {
				const response = await this.$util.rget('/vliti/block_book_and_delete_images', {
					key: albumKey
				});
				const isSuccess = Boolean(response && response.errcode === 0 && response.data === 'done');

				this.logAuditEvent(isSuccess ? 'block_album_done' : 'block_album_failed', {
					albumKey,
					response
				});
				this._monitorHelper.sendFrontendMonitor({
					monitorType: isSuccess ? 'event' : 'error',
					eventName: isSuccess ? 'mainloading_block_album_done' : 'mainloading_block_album_failed',
					message: isSuccess ? 'block album request success' : 'block album request failed',
					extra: {
						albumKey,
						response
					}
				});
			} catch (err) {
				this.logAuditEvent('block_album_error', {
					albumKey,
					error: err && err.message ? err.message : err
				});
				this._monitorHelper.sendFrontendMonitor({
					monitorType: 'error',
					eventName: 'mainloading_block_album_error',
					message: 'block album request error',
					extra: {
						albumKey,
						error: err && err.message ? err.message : err
					}
				});
			}
		},

		async deleteRejectedImageAndRetry () {
			const rejectedImageIndex = this.auditRejectedImageIndex;
			const configImages = (this.$store && this.$store.state && this.$store.state.config && Array.isArray(this.$store.state.config.images))
				? this.$store.state.config.images
				: [];
			const storeImages = (this.$store && this.$store.state && Array.isArray(this.$store.state.images))
				? this.$store.state.images
				: [];
			const configImage = configImages[rejectedImageIndex];
			const storeImage = storeImages[rejectedImageIndex];
			const imageId = (configImage && configImage.id)
				|| (storeImage && storeImage.id)
				|| '';
			const albumKey = (this.auditRejectedPayload && this.auditRejectedPayload.albumKey) || this.currentAlbumKey || '';

			if (rejectedImageIndex < 0 || !imageId || !albumKey) {
				this._monitorHelper.sendFrontendMonitor({
					monitorType: 'error',
					eventName: 'mainloading_delete_rejected_image_skip',
					message: 'skip delete rejected image request',
					extra: {
						rejectedImageIndex,
						imageId,
						albumKey
					}
				});
				return;
			}

			try {
				const response = await this.$util.rget('delete_image', {
					imageId: imageId,
					index: rejectedImageIndex,
					key: albumKey
				});
				this._monitorHelper.sendFrontendMonitor({
					monitorType: 'event',
					eventName: 'mainloading_delete_rejected_image_done',
					message: 'delete rejected image request success',
					extra: {
						rejectedImageIndex,
						imageId,
						albumKey,
						response
					}
				});
				this.refreshPage();
			} catch (err) {
				this._monitorHelper.sendFrontendMonitor({
					monitorType: 'error',
					eventName: 'mainloading_delete_rejected_image_error',
					message: 'delete rejected image request error',
					extra: {
						rejectedImageIndex,
						imageId,
						albumKey,
						error: err && err.message ? err.message : err
					}
				});
			}
		},

		handleSystemError (message, reasonCode = 'mainloading_system_error') {
			this.ended = true;
			this._auditHelper.abortAll('system_error');
			this._auditHelper.clearPollTimer();
			this.canWaitShow = false;
			this.statusText = '';
			this.isShow = true;
			this.canShow = true;
			this.auditRejectToastTitle = '⚠️提示';
			this.auditRejectToastContent = [
				'🔴 内容审核服务暂时不可用，',
				'🔴 当前相册已暂停打开，',
				'🔴 请稍后刷新重试'
			];
			this.auditRejectAction = 'reload';
			this.auditRejectedImageIndex = -1;
			this.auditRejectedImageUrl = '';
			this.auditRejectedPayload = null;
			this.logAuditEvent('system_error', { message });
			this.auditRejectToastShow = false;
			this.auditRejectToastRender = false;
			this.$nextTick(() => {
				this.auditRejectToastRender = true;
				this.$nextTick(() => {
					this.auditRejectToastShow = true;
				});
			});

			this._monitorHelper.sendFrontendMonitor({
				monitorType: 'error',
				eventName: 'mainloading_system_error',
				auditStatus: 'failed',
				message,
				extra: {
					reasonCode,
					auditTotalCount: this.auditTotalCount,
					auditFinishedCount: this.auditFinishedCount,
					loadTotalCount: this.loadTotalCount,
					loadFinishedCount: this.loadFinishedCount
				}
			});
		},

		showAuditRejectToast () {
			this.ended = true;
			this._auditHelper.abortAll('audit_rejected');
			this._auditHelper.clearPollTimer();
			if (this.canWaitEvent) {
				clearTimeout(this.canWaitEvent);
				this.canWaitEvent = null;
			}
			this.canWaitShow = false;
			this.statusText = '';
			this.isShow = true;
			this.canShow = true;
			this.auditRejectToastTitle = '⚠️注意';
			this.auditRejectToastContent = [];
			this.auditRejectAction = 'manual_review';
			this.auditRejectToastShow = false;
			this.auditRejectToastRender = false;
			this.$nextTick(() => {
				this.auditRejectToastRender = true;
				this.$nextTick(() => {
					this.auditRejectToastShow = true;
				});
			});
		},

		__onEnd () {
			const currentToken = this.loadToken;

			this.ended = true;
			this.isShow = false;

			// 确保进度条平滑到 100%
			this.animateProgressTo(100);

			this.hideEvent = setTimeout(() => {
				if (this.loadToken !== currentToken) {
					return;
				}

				this.progressNum = 0;
				this.displayProgressNum = 0;
				this.canShow = false;
				if (this.canWaitEvent) {
					clearTimeout(this.canWaitEvent);
					this.canWaitEvent = null;
				}
				this.hideEvent = null;
			}, 500);

			this._monitorHelper.sendFrontendMonitor({
				monitorType: 'event',
				eventName: 'mainloading_load_complete',
				auditStatus: 'passed',
				message: 'mainloading load complete',
				extra: {
					auditTotalCount: this.auditTotalCount,
					loadTotalCount: this.loadTotalCount
				}
			});
			this.options.onEnd && this.options.onEnd();
		},

		onAuditRejectToastChange (show) {
			this.auditRejectToastShow = show;
			if (!show) {
				this.auditRejectToastRender = false;
			}
		},

		onAuditRejectConfirm () {
			if (this.auditRejectAction === 'manual_review') {
				this.deleteRejectedImageAndRetry()
					.finally(() => {
						this.auditRejectToastShow = false;
					});
				return;
			}

			if (this.auditRejectAction === 'reload' && this.options.onReload) {
				this.options.onReload()
					.then(() => {
						this.refreshPage();
					})
					.catch(() => {
						this.refreshPage();
					});
				return;
			}

			this.refreshPage();
		},

		onAuditRejectCancel () {
			if (this.auditRejectAction !== 'manual_review') {
				return;
			}

			this.requestBlockAlbum(this.auditRejectedPayload || {})
				.finally(() => {
					this.refreshPage();
				});
			return;
		},

		refreshPage () {
			window.location.href = window.location.href;
		}
	}
};
</script>

<style>
	.mainloading {
		position: fixed;
		top: 0; left: 0; right: 0; bottom: 0;
		/* pointer-events: none; */
		z-index: 99;
		background-color: #ffeac8;
		background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 56 28' width='56' height='28'%3E%3Cpath fill='%23ed970e' fill-opacity='0.56' d='M56 26v2h-7.75c2.3-1.27 4.94-2 7.75-2zm-26 2a2 2 0 1 0-4 0h-4.09A25.98 25.98 0 0 0 0 16v-2c.67 0 1.34.02 2 .07V14a2 2 0 0 0-2-2v-2a4 4 0 0 1 3.98 3.6 28.09 28.09 0 0 1 2.8-3.86A8 8 0 0 0 0 6V4a9.99 9.99 0 0 1 8.17 4.23c.94-.95 1.96-1.83 3.03-2.63A13.98 13.98 0 0 0 0 0h7.75c2 1.1 3.73 2.63 5.1 4.45 1.12-.72 2.3-1.37 3.53-1.93A20.1 20.1 0 0 0 14.28 0h2.7c.45.56.88 1.14 1.29 1.74 1.3-.48 2.63-.87 4-1.15-.11-.2-.23-.4-.36-.59H26v.07a28.4 28.4 0 0 1 4 0V0h4.09l-.37.59c1.38.28 2.72.67 4.01 1.15.4-.6.84-1.18 1.3-1.74h2.69a20.1 20.1 0 0 0-2.1 2.52c1.23.56 2.41 1.2 3.54 1.93A16.08 16.08 0 0 1 48.25 0H56c-4.58 0-8.65 2.2-11.2 5.6 1.07.8 2.09 1.68 3.03 2.63A9.99 9.99 0 0 1 56 4v2a8 8 0 0 0-6.77 3.74c1.03 1.2 1.97 2.5 2.79 3.86A4 4 0 0 1 56 10v2a2 2 0 0 0-2 2.07 28.4 28.4 0 0 1 2-.07v2c-9.2 0-17.3 4.78-21.91 12H30zM7.75 28H0v-2c2.81 0 5.46.73 7.75 2zM56 20v2c-5.6 0-10.65 2.3-14.28 6h-2.7c4.04-4.89 10.15-8 16.98-8zm-39.03 8h-2.69C10.65 24.3 5.6 22 0 22v-2c6.83 0 12.94 3.11 16.97 8zm15.01-.4a28.09 28.09 0 0 1 2.8-3.86 8 8 0 0 0-13.55 0c1.03 1.2 1.97 2.5 2.79 3.86a4 4 0 0 1 7.96 0zm14.29-11.86c1.3-.48 2.63-.87 4-1.15a25.99 25.99 0 0 0-44.55 0c1.38.28 2.72.67 4.01 1.15a21.98 21.98 0 0 1 36.54 0zm-5.43 2.71c1.13-.72 2.3-1.37 3.54-1.93a19.98 19.98 0 0 0-32.76 0c1.23.56 2.41 1.2 3.54 1.93a15.98 15.98 0 0 1 25.68 0zm-4.67 3.78c.94-.95 1.96-1.83 3.03-2.63a13.98 13.98 0 0 0-22.4 0c1.07.8 2.09 1.68 3.03 2.63a9.99 9.99 0 0 1 16.34 0z'%3E%3C/path%3E%3C/svg%3E");
		animation: fadeIn .3s both;
	}
	.mainloading .st-toast {
		z-index: 120;
	}
	.mainloading .audit-reject-slot {
		padding: 6px 8px 0;
		text-align: center;
	}
	.mainloading .audit-reject-preview {
		display: flex;
		align-items: center;
		justify-content: center;
		max-width: 120px;
		max-height: 120px;
		min-height: 72px;
		margin: 0 auto 12px;
		border-radius: 12px;
		overflow: hidden;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
		background: #f7f7f7;
		padding: 6px;
		box-sizing: border-box;
	}
	.mainloading .audit-reject-preview-img {
		display: block;
		max-width: 100%;
		max-height: 100%;
		width: auto;
		height: auto;
		object-fit: contain;
	}
	.mainloading .audit-reject-slot-text {
		color: #5f3903;
		font-size: 14px;
		line-height: 1.6;
	}
	.mainloading .audit-reject-slot-title {
		font-size: 15px;
		font-weight: 700;
		margin-bottom: 6px;
	}
	.mainloading .audit-reject-slot-desc {
		color: rgba(95, 57, 3, 0.78);
		margin-bottom: 4px;
	}
	.mainloading-box {
		position: absolute;
		width: 414px;
		height: 54px;
		top: 50%;
		margin-top: -27px;
		left: 50%;
		margin-left: -207px;
		border-radius: 12px;
		background-color: white;
		box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.23);
	}
	.mainloading-con {
		position: absolute;
		width: 400px;
		height: 40px;
		top: 50%;
		left: 50%;
		margin-top: -20px;
		margin-left: -200px;
		background-color: #fff;
		border-radius: 5px;
	}
	.mainloading-bar {
		position: absolute;
		height: 100%;
		top: 0;
		left: 0;
		background-color: #ED970E;
		border-radius: 5px;
		/* 使用 JS requestAnimationFrame 动画，移除 CSS transition 避免冲突 */
		/* 保留轻微的光泽效果 */
		background-image: linear-gradient(
			90deg,
			rgba(255, 255, 255, 0) 0%,
			rgba(255, 255, 255, 0.25) 50%,
			rgba(255, 255, 255, 0) 100%
		);
		background-size: 200% 100%;
		animation: barShine 2s ease-in-out infinite;
	}
	@keyframes barShine {
		0% {
			background-position: -200% 0;
		}
		100% {
			background-position: 200% 0;
		}
	}
	.mainloading-per {
		color: white;
		font-weight: bold;
		height: 40px;
		line-height: 40px;
		padding-left: 12px;
		font-size: 20px;
		text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
	}
	.mainloading-icon {
		position: absolute;
		width: 76px;
		height: 76px;
		border-radius: 50%;
		transform: rotate(20deg);
		top: 50%;
		margin-top: -40px;
		right: -30px;
		border: solid 4px white;
	}
	.mainloading-waiting {
		font-size: 0.704rem;
		font-weight: bold;
		width: 250px;
		padding: 8px 0;
		text-align: center;
		-webkit-text-decoration: revert;
		bottom: -100px;
		color: #5f3903;
		left: 50%;
		margin-left: -125px;
		border-radius: 12px;
		box-shadow: 0 0 6px 1px #5f3903;
		animation: float-y 5s ease-in-out infinite alternate;
		background-color: #fff7ea;
	}
	.mainloading-tips {
		position: fixed;
		left: 50%;
		bottom: 20%;
		transform: translateX(-50%);
		text-align: center;
		color: rgba(95, 57, 3, 0.7);
		font-size: 14px;
		line-height: 1.6;
		max-width: 80%;
		padding: 12px 24px;
		background: rgba(255, 255, 255, 0.4);
		border-radius: 20px;
		backdrop-filter: blur(4px);
		animation: fadeInTips 0.5s ease-out;
	}
	.mainloading-tips .tips-icon {
		font-size: 18px;
		margin: 0 0 6px 0;
		opacity: 0.8;
		animation: tipsIconPulse 2s ease-in-out infinite;
	}
	@keyframes tipsIconPulse {
		0%, 100% {
			transform: scale(1);
			opacity: 0.8;
		}
		50% {
			transform: scale(1.15);
			opacity: 1;
		}
	}
	.mainloading-tips .tips-text {
		margin: 0;
		font-weight: 500;
		letter-spacing: 0.5px;
	}
	@keyframes fadeInTips {
		from {
			opacity: 0;
			transform: translateX(-50%) translateY(10px);
		}
		to {
			opacity: 1;
			transform: translateX(-50%) translateY(0);
		}
	}
	@keyframes fadeOutTips {
		from {
			opacity: 1;
			transform: translateX(-50%) translateY(0);
		}
		to {
			opacity: 0;
			transform: translateX(-50%) translateY(-10px);
		}
	}
	.tips-fade-enter-active {
		animation: tipsSlideIn 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
	}
	.tips-fade-leave-active {
		animation: tipsSlideOut 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);
	}
	@keyframes tipsSlideIn {
		0% {
			opacity: 0;
			transform: translateY(10px) scale(0.95);
			filter: blur(2px);
		}
		50% {
			filter: blur(0px);
		}
		100% {
			opacity: 1;
			transform: translateY(0) scale(1);
			filter: blur(0px);
		}
	}
	@keyframes tipsSlideOut {
		0% {
			opacity: 1;
			transform: translateY(0) scale(1);
		}
		100% {
			opacity: 0;
			transform: translateY(-8px) scale(0.98);
		}
	}
</style>
